export default "__VITE_ASSET__fCkpIAim__"